import type { UserDecathlon } from 'src/components/account/types'

import { axiosClient } from '../../services/axiosInstance'

const STORES_URL =
  'https://decathlonstore.myvtex.com/api/dataentities/SL/search?_fields=address,name,openingHours,pageLink,phone,store_id,status_active&_where=status_active=true'

const SPORTS_URL =
  'https://decathlonstore.myvtex.com/api/dataentities/SP/search?_fields=id,image,name,name_english,Sports_id,sports_practice,universo'

export type MasterDataOption = { id: string; value: string }

type StoreRecord = { name: string; store_id: string }
type SportRecord = { Sports_id: string; name: string }

let storesPromise: Promise<MasterDataOption[]> | null = null
let sportsPromise: Promise<MasterDataOption[]> | null = null

function sameId(left?: string | number, right?: string | number) {
  if (left == null || right == null) return false

  return Number(left) === Number(right)
}

async function loadStores() {
  const { data } = await axiosClient.get<StoreRecord[]>(STORES_URL, {
    headers: { 'rest-range': 'resources=0-500' },
  })

  return (data ?? []).map((store) => ({
    id: store.store_id,
    value: store.name,
  }))
}

async function loadSports() {
  const { data } = await axiosClient.get<SportRecord[]>(SPORTS_URL, {
    headers: { 'rest-range': 'resources=0-100' },
  })

  return (data ?? []).map((sport) => ({
    id: sport.Sports_id,
    value: sport.name,
  }))
}

export function resetMasterDataFavoritesCache() {
  storesPromise = null
  sportsPromise = null
}

export function fetchFavoriteStores() {
  if (!storesPromise) {
    storesPromise = loadStores().catch((error) => {
      storesPromise = null
      throw error
    })
  }

  return storesPromise
}

export function fetchFavoriteSports() {
  if (!sportsPromise) {
    sportsPromise = loadSports().catch((error) => {
      sportsPromise = null
      throw error
    })
  }

  return sportsPromise
}

export function findFavoriteStore(
  stores: MasterDataOption[],
  thirdNum?: string
) {
  return stores.find((store) => sameId(store.id, thirdNum))
}

export function findFavoriteSports(
  sports: MasterDataOption[],
  sportIds?: string[]
) {
  if (!sportIds?.length) return []

  return sports.filter((sport) =>
    sportIds.some((sportId) => sameId(sport.id, sportId))
  )
}

export async function resolveFavoriteNames(user: UserDecathlon) {
  try {
    const [stores, sports] = await Promise.all([
      fetchFavoriteStores(),
      fetchFavoriteSports(),
    ])

    const favoriteStore = findFavoriteStore(
      stores,
      user.getFavoriteStore?.third_num
    )

    const favoriteSports = findFavoriteSports(
      sports,
      user.getSportsPractice?.map((item) => item.sport_id)
    )

    return {
      ...(favoriteStore?.value ? { favorite_store: favoriteStore.value } : {}),
      ...(favoriteSports.length
        ? { favorite_sports: favoriteSports.map((item) => item.value) }
        : {}),
    }
  } catch {
    return {}
  }
}
